import { useSuspenseQuery } from '@apollo/client'
import {
  FetchMeDocument,
  type FetchMeQuery,
  FetchSalescoreObjectPermissionUserDocument,
  FetchSalescoreObjectPermissionUserGroupsDocument,
  type FetchSalescoreObjectPermissionUserGroupsQuery,
  type FetchSalescoreObjectPermissionUserQuery,
  FetchViewPermissionUserGroupsDocument,
  type FetchViewPermissionUserGroupsQuery,
  FetchViewPermissionUsersDocument,
  type FetchViewPermissionUsersQuery,
} from '@salescore/client-api'
import { getOrganizationIdFromPath } from '@salescore/client-base'

export interface Me {
  myUser: FetchMeQuery['myUser']
  myIdentity: FetchMeQuery['myUser']['identity']
  organization: FetchMeQuery['myUser']['organization']
  viewPermissionUsers?: FetchViewPermissionUsersQuery['viewPermissionUsers']
  viewPermissionUserGroups?: FetchViewPermissionUserGroupsQuery['viewPermissionUserGroups']
  salescoreObjectPermissionUsers?: FetchSalescoreObjectPermissionUserQuery['salescoreObjectPermissionUsers']
  salescoreObjectPermissionUserGroups?: FetchSalescoreObjectPermissionUserGroupsQuery['salescoreObjectPermissionUserGroups']
}

export function useMe(): Me {
  const organizationId = getOrganizationIdFromPath()
  const {
    data: { myUser },
  } = useSuspenseQuery(FetchMeDocument, {
    variables: { organizationId },
    fetchPolicy: 'no-cache',
  })
  // FEでの権限管理のためにUser紐づくviewPermissionデータを取得(meに紐づけるべき悩ましい)
  const {
    data: { viewPermissionUsers },
  } = useSuspenseQuery(FetchViewPermissionUsersDocument, {
    variables: { organizationId, userId: myUser.id },
    fetchPolicy: 'cache-first',
  })
  const {
    data: { viewPermissionUserGroups },
  } = useSuspenseQuery(FetchViewPermissionUserGroupsDocument, {
    variables: {
      organizationId,
      userGroupIds:
        myUser.resourceUser?.user_group_ids === undefined ||
        myUser.resourceUser.user_group_ids === null ||
        myUser.resourceUser.user_group_ids.length === 0
          ? [`no-team`]
          : myUser.resourceUser.user_group_ids,
    },
    fetchPolicy: 'cache-first',
  })

  const {
    data: { salescoreObjectPermissionUsers },
  } = useSuspenseQuery(FetchSalescoreObjectPermissionUserDocument, {
    variables: { organizationId, userId: myUser.id },
    fetchPolicy: 'cache-first',
  })
  const {
    data: { salescoreObjectPermissionUserGroups },
  } = useSuspenseQuery(FetchSalescoreObjectPermissionUserGroupsDocument, {
    variables: {
      organizationId,
      userGroupIds:
        // eslint-disable-next-line eqeqeq
        myUser.resourceUser?.user_group_ids == null || myUser.resourceUser.user_group_ids.length === 0
          ? [`no-team`]
          : myUser.resourceUser.user_group_ids,
    },
    fetchPolicy: 'cache-first',
  })

  const { identity: myIdentity, organization } = myUser

  return {
    myUser,
    myIdentity,
    organization,
    viewPermissionUsers,
    viewPermissionUserGroups,
    salescoreObjectPermissionUsers,
    salescoreObjectPermissionUserGroups,
  }
}

export function useOrganization() {
  const organizationId = getOrganizationIdFromPath()
  const {
    data: { myUser: me },
  } = useSuspenseQuery(FetchMeDocument, {
    variables: { organizationId },
    fetchPolicy: 'cache-first',
  })
  return me.organization
}
